import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/meritve/drob/volna/merilo";

export const fetchWoolFinenessPage = createAsyncThunk(
  "wool/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchWoolFinenessById = createAsyncThunk(
  "wool/byId",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(`${baseUrl}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const createWoolFineness = createAsyncThunk(
  "wool/create",
  async (woolFineness, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post(baseUrl, woolFineness);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const updateWoolFineness = createAsyncThunk(
  "wool/update",
  async ({ id, woolFineness }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.put(`${baseUrl}/${id}`, woolFineness);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const deleteWoolFineness = createAsyncThunk(
  "wool/delete",
  async ({ id, version }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.delete(`${baseUrl}/${id}`, { version });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const woolFinenessSlice = createSlice({
  name: "woolFineness",
  initialState: {
    details: null,
    page: null,
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWoolFinenessPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchWoolFinenessPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchWoolFinenessPage.pending, (state, _action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchWoolFinenessById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.details = action.payload;
      })
      .addCase(fetchWoolFinenessById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchWoolFinenessById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createWoolFineness.fulfilled, (state, _) => {
        state.isLoading = false;
      })
      .addCase(createWoolFineness.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createWoolFineness.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateWoolFineness.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateWoolFineness.fulfilled, (state, action) => {
        state.isLoading = false;
        state.details = action.payload;
      })
      .addCase(updateWoolFineness.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteWoolFineness.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteWoolFineness.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteWoolFineness.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default woolFinenessSlice.reducer;
